import { BasketAddonModel } from './BasketAddonModel';

export class BasketCareKitAddonModel extends BasketAddonModel {
    public materials: string[];
    public name: string;
    public relatedCartEntries?: number[];
}